import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";
import * as Grid from "components/Grid";
import cls from "./GovernmentServices.module.scss";

const GovernmentServices = ({
  title,
  activityType,
  governmentServices = [],
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className={cls.wrapper}>
      <div
        className={cls.head}
        onClick={() => setOpen(prev => !prev)}
        style={{ cursor: "pointer" }}
      >
        <div className={cls.headLeft}>
          <Icons.FolderCode />
        </div>

        <div className={cls.headCenter}>
          <div className={cls.headCenterTitle}>{t(title)}</div>

          <div className={cls.headCenterStatuses}>
            {activityType && (
              <div className={cls.headCenterStatus}>
                {t(activityType)}
              </div>
            )}
          </div>
        </div>
        <div className={cls.headRight}>
          {open ? <Icons.ChevronDown /> : <Icons.ChevronUp />}
        </div>
      </div>

      {open && governmentServices.length > 0 && (
        <div className={cls.body}>
          <Grid.Row gutter={[24, 24]}>
            <Grid.Col xs={24}>
              <ul className={cls.bodyList}>
                {governmentServices.map((item, index) => (
                  <li className={cls.bodyListItem} key={item.id}>
                    <span>{index + 1}</span>
                    <span>{item?.name?.uz}</span>
                  </li>
                ))}
              </ul>
            </Grid.Col>
          </Grid.Row>
        </div>
      )}
    </div>
  );
};

export default GovernmentServices;
